import React from "react";

const sections = [
  ["summary", "Passage Summary"],
  ["commentary", "Pastor's Reflection"],
  ["meditation_question", "Today's Question"],
  ["prayer_direction", "Prayer Direction"],
];

const NEU_RAISED_MD =
  "shadow-[-8px_-8px_18px_var(--outer-shadow-light),8px_8px_18px_var(--outer-shadow-dark)]";

const PastoralGuide = ({ content }) => {
  const cardClass = `rounded-[2rem] bg-canvas-base p-space-lg md:p-space-xl ${NEU_RAISED_MD}`;

  if (!content) {
    return (
      <section className={cardClass}>
        <div className="flex flex-col gap-space-xs">
          <span className="text-label-sm uppercase tracking-widest text-accent-gold-deep font-bold">
            Methodical Devotion
          </span>
          <h2 className="font-noto-serif text-headline-md text-neu-primary">
            Pastoral Guide
          </h2>
        </div>
        <p className="mt-space-md text-body-lg text-slate-muted">
          No published guide has been added for this passage yet.
        </p>
      </section>
    );
  }

  return (
    <section className={cardClass} lang={content.language_code}>
      <div className="flex flex-col gap-space-xs">
        <span className="text-label-sm uppercase tracking-widest text-accent-gold-deep font-bold">
          Methodical Devotion
        </span>
        <h2 className="font-noto-serif text-headline-md text-neu-primary">
          Pastoral Guide
        </h2>
      </div>

      <div className="mt-space-lg grid gap-space-lg">
        {sections.map(([field, label]) =>
          content[field] ? (
            <article
              key={field}
              className="pt-space-md border-t border-[color:var(--outer-shadow-dark)]/20"
            >
              <h3 className="font-noto-serif text-headline-sm text-neu-primary">
                <span className="text-label-sm uppercase tracking-widest text-accent-gold-deep font-bold block mb-1">
                  {label}
                </span>
              </h3>
              <p className="mt-2 whitespace-pre-wrap leading-8 text-body-lg text-on-surface-variant">
                {content[field]}
              </p>
            </article>
          ) : null
        )}
      </div>
    </section>
  );
};

export default PastoralGuide;
